<template>
    <v-card class="weather-widget" max-width="344">
        <v-card-item>
            <v-card-title class="subtitle font-medium"
                >Kuala Lumpur</v-card-title
            >

            <v-card-subtitle>
                <v-icon
                    icon="mdi-alert"
                    size="18"
                    color="error"
                    class="mr-1 pb-1"
                ></v-icon>

                Unfavourable Weather Conditions
            </v-card-subtitle>
        </v-card-item>

        <v-card-text class="py-0">
            <v-row align="center" hide-gutters no-gutters>
                <v-col class="text-h2" cols="6"> 32&deg;C </v-col>

                <v-col cols="6" class="text-right">
                    <v-icon
                        size="88"
                        color="error"
                        icon="mdi-weather-hurricane"
                    ></v-icon>
                </v-col>
            </v-row>
        </v-card-text>

        <v-list-item density="compact">
            <v-list-item-avatar left>
                <v-icon icon="mdi-weather-windy"></v-icon>
            </v-list-item-avatar>

            <v-list-item-subtitle>123 km/h</v-list-item-subtitle>
        </v-list-item>

        <v-list-item density="compact">
            <v-list-item-avatar left>
                <v-icon icon="mdi-weather-pouring"></v-icon>
            </v-list-item-avatar>

            <v-list-item-subtitle>48%</v-list-item-subtitle>
        </v-list-item>

        <v-expand-transition>
            <div v-if="expand">
                <v-list class="transparent">
                    <v-list-item
                        v-for="item in forecast"
                        :key="item.day"
                        :title="item.day"
                        :append-icon="item.icon"
                        :subtitle="item.temp"
                    >
                    </v-list-item>
                </v-list>
            </div>
        </v-expand-transition>

        <v-divider></v-divider>

        <v-card-actions>
            <v-btn @click="expand = !expand"> Full Report </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    data: () => ({
        labels: {
            0: "SU",
            1: "MO",
            2: "TU",
            3: "WED",
            4: "TH",
            5: "FR",
            6: "SA",
        },
        expand: false,
        time: 0,
        forecast: [
            {
                day: "Tuesday",
                icon: "mdi-white-balance-sunny",
                temp: "32\xB0/29\xB0",
            },
            {
                day: "Wednesday",
                icon: "mdi-white-balance-sunny",
                temp: "33\xB0/30\xB0",
            },
            { day: "Thursday", icon: "mdi-cloud", temp: "30\xB0/29\xB0" },
        ],
    }),
};
</script>

<style scoped>
.weather-widget {
    border-radius: 15px;
}
</style>
